import { useEffect } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { initLanguageRedirect } from '../lib/languageRedirect';
import { initReveal } from '../lib/reveal';

export default function RootLayout() {
  useEffect(() => {
    initLanguageRedirect();
  }, []);

  // Bounce scroll reveals (client only; prerendered HTML stays fully visible).
  useEffect(() => initReveal(), []);

  return (
    <>
      <Outlet />
      <ScrollRestoration />
      <Analytics />
    </>
  );
}
